import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {uniqBy} from 'lodash/fp';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {GetOrganizationCentersAction, userDetailAction} from '../action';

function* execute({payload: {organizationId}}: GetOrganizationCentersAction): SagaIterator {
    yield* put(userDetailAction.setLoading('getCenters', true));

    const response = yield* call(Api.findAllCentersByOrganizationId, {organizationId});

    if (response.isSuccess) {
        yield* put(userDetailAction.setCentersOptions(uniqBy('id', [...response.data])));
    } else {
        yield putAll(showBeError(response, t('userDetail')('organizationsLoading')));
    }

    yield* put(userDetailAction.setLoading('getCenters', false));
}

export function* getOrganizationCentersSaga(): SagaIterator {
    yield takeLatestF('userDetail/GET_ORGANIZATION_CENTERS', execute);
}
